/*
  Southern Scholar Blue Bundle landing page, shared behaviour.
  Ported from the approved static page. Do not add tracking scripts here.

  PRICING IS EDITED IN ONE PLACE: the "Buy Box" section. The bundle total, the saving and the discount
  percentage are all worked out below from the per pair prices, so they cannot drift
  apart the way typed totals do. The Hero, the Comparison Table row, the Closing CTA
  and the Sticky Buy Bar all read from the same calculation.

  The live offer is $15 a pair at 40 percent off. Change both "Price per pair, in the bundle"
  and "Over the calf pair, in the bundle" together when the offer moves. The Over-The-Calf
  price is typed separately and does not derive from the Mid-Calf price.

  This deliberately does NOT bail out when the Buy Box is missing. Every section on this
  page is meant to be hideable, and the scroll reveals start at opacity 0, so an early
  return would leave most of the page invisible.
*/
(function () {
  "use strict";

  var DEFAULTS = {
    pairList: "25.00",
    pairSale: "15.00",
    ctaLabel: "Claim the Blue Bundle",
    sizing: "Mid-Calf or Over-The-Calf · Sizes 7-14",
    finalCtaHref:
      "https://southernscholar.com/products/the-blue-bundle-6-pack"
  };

  var FALLBACK_PAIRS = 6; // used only if the Buy Box is hidden or has no items

  function money(n) {
    return "$" + n.toFixed(2).replace(/\.00$/, "");
  }

  function money2(n) {
    return "$" + n.toFixed(2);
  }

  function numberFromMoney(value) {
    return Number(String(value).replace(/[^0-9.]/g, ""));
  }

  function setText(selector, value) {
    if (value === undefined || value === null) return;
    document.querySelectorAll(selector).forEach(function (element) {
      element.textContent = value;
    });
  }

  /* Attach a listener at most once per element, so re-running after a theme editor
     section reload cannot double fire an accordion or a size toggle. */
  function once(element, key, type, handler) {
    var flag = "ssbb" + key;
    if (element.dataset[flag] === "1") return false;
    element.dataset[flag] = "1";
    element.addEventListener(type, handler);
    return true;
  }

  function boot() {
    var offer = Object.assign({}, DEFAULTS, window.SSBB_OFFER || {});
    var pairList = numberFromMoney(offer.pairList) || numberFromMoney(DEFAULTS.pairList);
    var pairSale = numberFromMoney(offer.pairSale) || numberFromMoney(DEFAULTS.pairSale);

    setText("[data-sizing]", offer.sizing);
    setText("[data-offer-label]", offer.ctaLabel);
    document.querySelectorAll("[data-offer-link]").forEach(function (link) {
      link.href = offer.finalCtaHref;
    });

    var items = Array.prototype.slice.call(document.querySelectorAll(".bundle-item"));

    /* ----------------------------------------------------------------------------
       ADD THE SIX SOCKS TO THE REAL CART, THEN LET THE STORE'S SLIDE OUT CART OPEN.

       How the money works, checked against the live store on 2026-08-03: the $90 bundle
       product itself CANNOT go in the cart, the store's own bundle page blocks it. What
       goes in is the six individual socks at their own price, and an automatic discount
       on the store called "The Blue Bundle (6-Pack)" then takes 40% off by itself. There
       is no discount code involved. Proven with a real cart: six socks went from $216 to
       $129.60, which is $150 to $90 in US dollars.

       Whichever height the shopper picked for each pair is the one added, because Mid-Calf
       and Over-The-Calf are separate items on the store with their own prices.

       If anything here fails the button falls back to its own href, which is the product
       page, so a click never does nothing.
    ---------------------------------------------------------------------------- */
    var addButton = document.querySelector("[data-bundle-add]");

    function chosenCartItems() {
      var chosen = [];
      var missing = [];
      items.forEach(function (item) {
        var otc = item.dataset.size === "otc";
        var id = otc ? item.dataset.otcVariant : item.dataset.midVariant;
        if (!id || !String(id).trim()) {
          missing.push(item.dataset.itemName || "one of the pairs");
          return;
        }
        chosen.push({ id: Number(String(id).trim()), quantity: 1 });
      });
      return { items: chosen, missing: missing };
    }

    function showAddError(message) {
      var box = document.querySelector("[data-bundle-add-error]");
      if (!box) return;
      box.textContent = message;
      box.hidden = false;
    }

    function clearAddError() {
      var box = document.querySelector("[data-bundle-add-error]");
      if (!box) return;
      box.hidden = true;
      box.textContent = "";
    }

    if (addButton) {
      once(addButton, "BundleAdd", "click", function (event) {
        var picked = chosenCartItems();

        /* Nothing set up yet, or a pair is missing its number: do not pretend. Let the
           link do its normal job and take them to the product page instead. */
        if (!picked.items.length || picked.missing.length) {
          return;
        }

        event.preventDefault();
        clearAddError();

        if (addButton.dataset.busy === "1") return;
        addButton.dataset.busy = "1";
        addButton.classList.add("is-loading");
        var label = addButton.querySelector("[data-bundle-add-label]");
        var originalLabel = label ? label.textContent : "";
        if (label) label.textContent = "Adding to bag...";

        function done() {
          addButton.dataset.busy = "";
          addButton.classList.remove("is-loading");
          if (label) label.textContent = originalLabel;
        }

        /* Send them to the product page as a last resort, so a shopper is never stuck. */
        function bailOut(message) {
          done();
          showAddError(message);
          window.location.href = addButton.getAttribute("href");
        }

        var cartAddUrl =
          (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || "/cart/add";

        fetch(cartAddUrl + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: picked.items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(
                function (body) {
                  throw new Error((body && body.description) || "That did not go in the bag.");
                },
                function () {
                  throw new Error("That did not go in the bag.");
                }
              );
            }
            return response.json();
          })
          .then(function () {
            /* The store's cart listens for this, refreshes itself and slides open.
               Watched for theme:product:added so the button stops spinning when it does. */
            var opened = false;
            document.addEventListener("theme:product:added", function onAdded() {
              opened = true;
              document.removeEventListener("theme:product:added", onAdded);
              done();
            });
            document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));

            /* If the slide out cart is not on the page for any reason, send them to the
               cart page rather than leave them looking at an unchanged button. */
            setTimeout(function () {
              if (opened) return;
              done();
              var cartUrl =
                (window.theme && window.theme.routes && window.theme.routes.cart_url) || "/cart";
              window.location.href = cartUrl;
            }, 3500);
          })
          .catch(function (error) {
            bailOut(error && error.message ? error.message : "That did not go in the bag.");
          });
      });
    }

    function priceFor(item, which) {
      var otc = item.dataset.size === "otc";
      var raw = otc
        ? which === "list"
          ? item.dataset.otcList
          : item.dataset.otcSale
        : which === "list"
          ? item.dataset.midList
          : item.dataset.midSale;
      var n = Number(raw);
      if (n > 0) return n;
      return which === "list" ? pairList : pairSale;
    }

    /* Every figure below is CALCULATED. Nothing here is a typed total. */
    function recalc() {
      var sale = 0;
      var list = 0;

      if (items.length) {
        items.forEach(function (item) {
          var l = priceFor(item, "list");
          var s = priceFor(item, "sale");
          list += l;
          sale += s;
          var off = item.querySelector("[data-pair-off]");
          if (off && l > 0) {
            off.textContent = Math.round(((l - s) / l) * 100) + "% off";
          }
        });
      } else {
        sale = pairSale * FALLBACK_PAIRS;
        list = pairList * FALLBACK_PAIRS;
      }

      var save = list - sale;
      var pct = list > 0 ? Math.round((save / list) * 100) : 0;

      setText("[data-sale]", money(sale));
      setText("[data-msrp]", money(list));
      setText("[data-save]", money(save));
      setText("[data-discount]", pct + "% off");
      setText("[data-discount-pct]", pct + "%");
      /* Comparison Table row, so it can never quote a stale per pair price. */
      setText("[data-cmp-list]", money2(pairList));
      setText("[data-cmp-sale]", money2(pairSale));
    }

    /* Per pair height toggles, with live repricing of the whole bundle. */
    items.forEach(function (item) {
      var priceStrike = item.querySelector("[data-pair-list]");
      var priceSale = item.querySelector("[data-pair-sale]");
      item.querySelectorAll(".bundle-size-option").forEach(function (option) {
        once(option, "Size", "click", function () {
          item.dataset.size = option.dataset.size;
          item.querySelectorAll(".bundle-size-option").forEach(function (sibling) {
            var on = sibling === option;
            sibling.classList.toggle("active", on);
            sibling.setAttribute("aria-pressed", String(on));
          });
          if (priceStrike) priceStrike.textContent = money2(priceFor(item, "list"));
          if (priceSale) priceSale.textContent = money2(priceFor(item, "sale"));
          recalc();
        });
      });
      /* Paint the starting per pair price from the live settings. */
      if (priceStrike) priceStrike.textContent = money2(priceFor(item, "list"));
      if (priceSale) priceSale.textContent = money2(priceFor(item, "sale"));
    });

    recalc();

    /* Scroll reveals. */
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var revealItems = document.querySelectorAll(".reveal-item:not([data-ssbbReveal])");
    var revealSection = document.querySelector(".reveal-section");

    if (reducedMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(function (item) {
        item.classList.add("is-revealed");
      });
      if (revealSection) revealSection.classList.add("is-color");
    } else {
      var revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -5% 0px" }
      );
      revealItems.forEach(function (item) {
        item.dataset.ssbbReveal = "1";
        revealObserver.observe(item);
      });

      if (revealSection) {
        var colorObserver = new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add("is-color");
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.22 }
        );
        colorObserver.observe(revealSection);
      }
    }

    /* FAQ pairs and the Buy Box accordions. */
    document.querySelectorAll(".faq-question").forEach(function (question) {
      once(question, "Faq", "click", function () {
        var isOpen = question.getAttribute("aria-expanded") === "true";
        question.setAttribute("aria-expanded", String(!isOpen));
      });
    });

    document.querySelectorAll(".bundle-accordion-row").forEach(function (row) {
      once(row, "Acc", "click", function () {
        var isOpen = row.getAttribute("aria-expanded") === "true";
        row.setAttribute("aria-expanded", String(!isOpen));
      });
    });

    /* Buy Box image gallery. */
    var galleryMain = document.querySelector(".bundle-main img");
    var galleryThumbs = Array.prototype.slice.call(document.querySelectorAll(".bundle-thumbnail"));
    if (galleryMain && galleryThumbs.length) {
      var sources = galleryThumbs.map(function (thumb) {
        var img = thumb.querySelector("img");
        return img ? img.getAttribute("src") : null;
      });
      var galleryIndex = 0;
      var showImage = function (index) {
        galleryIndex = (index + sources.length) % sources.length;
        if (sources[galleryIndex]) galleryMain.setAttribute("src", sources[galleryIndex]);
        galleryThumbs.forEach(function (thumb, i) {
          var isActive = i === galleryIndex;
          thumb.classList.toggle("active", isActive);
          if (isActive) {
            thumb.setAttribute("aria-current", "true");
          } else {
            thumb.removeAttribute("aria-current");
          }
        });
      };
      galleryThumbs.forEach(function (thumb, i) {
        once(thumb, "Thumb", "click", function () {
          showImage(i);
        });
      });
      var prevArrow = document.querySelector(".bundle-gallery-arrow.prev");
      var nextArrow = document.querySelector(".bundle-gallery-arrow.next");
      if (prevArrow)
        once(prevArrow, "Prev", "click", function () {
          showImage(galleryIndex - 1);
        });
      if (nextArrow)
        once(nextArrow, "Next", "click", function () {
          showImage(galleryIndex + 1);
        });
    }

    /* Sticky Buy Bar, appears once the hero has scrolled away. */
    var hero = document.querySelector("#hero");
    var mobileOffer = document.querySelector("#mobile-offer");
    if (hero && mobileOffer && !mobileOffer.dataset.ssbbSticky) {
      mobileOffer.dataset.ssbbSticky = "1";
      if ("IntersectionObserver" in window) {
        var heroObserver = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            mobileOffer.classList.toggle(
              "is-visible",
              !entry.isIntersecting && window.scrollY > hero.offsetHeight * 0.7
            );
          },
          { threshold: 0 }
        );
        heroObserver.observe(hero);
      } else {
        window.addEventListener(
          "scroll",
          function () {
            mobileOffer.classList.toggle("is-visible", window.scrollY > hero.offsetHeight);
          },
          { passive: true }
        );
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /*
    The theme editor re-renders one section at a time. Without this, a headline edit would
    leave that section's prices blank until a full page reload, which reads as broken.
    Re-running is safe because every listener above is attached at most once per element.
  */
  document.addEventListener("shopify:section:load", boot);
})();
